import { Injectable } from '@angular/core';
import { ICompanyObjectiveSettings } from '../models/CompanyObjectiveSettings';
import { EmployeeObjectiveStatistics } from '../models/EmployeeObjectiveStatistics';
import { IObjectiveSettings } from '../models/ObjectiveSettings';

@Injectable({
  providedIn: 'root'
})
export class EmployeeObjectiveStatisticsServiceService {

  constructor() { }

  public getWeightAndTotalFromStatistic(statistic: EmployeeObjectiveStatistics, settings: IObjectiveSettings): { totalWeight: number, totalObjectives: number } {
    const weight = settings.useReviewPeriod ? statistic?.totalWeightPerReviewPeriod : statistic?.totalWeightStatus;
    const objectives = settings.useReviewPeriod ? statistic?.totalNumberPerReviewPeriod : statistic?.totalNumberStatus;

    return { totalWeight: weight, totalObjectives: objectives }
  }
}
